

import { type State } from '../../types';
import { type TravelerProfile } from '../../../types/travelerProfile';

const selectRoot = (state: State) => {
  return state.entities.travelers;
}

export const selectTravelerProfile = (state: State): TravelerProfile | undefined => {
  return selectRoot(state).travelerProfile;
}
